import { IEvents } from "@/models/IEvents";

export const parseApiDate = (dateStr: string): Date => {
  if (!dateStr) return new Date(NaN);

  // ISO format (2025-12-19)
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return new Date(`${dateStr}T00:00:00`);
  }

  // old format fallback
  const cleaned = dateStr.replace(/^[A-Za-z]{3,9},\s*/, "");
  const parts = cleaned.split(" ");

  if (parts.length !== 3) return new Date(NaN);

  const [day, month, year] = parts;
  return new Date(`${month} ${day}, ${year}`);
};

export const eventSpansMonth = (
  startDateStr: string,
  endDateStr: string | undefined,
  monthKey: string,
) => {
  const start = parseApiDate(startDateStr);
  const end = endDateStr ? parseApiDate(endDateStr) : start;

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

  const [year, month] = monthKey.split("-").map(Number);
  const monthStart = new Date(year, month - 1, 1);
  const monthEnd = new Date(year, month, 0);

  return start <= monthEnd && end >= monthStart;
};

export const formatEventDateRange = (event: IEvents) => {
  const start = parseApiDate(event.startDate);
  if (isNaN(start.getTime())) return "";

  // SINGLE DAY
  if (!event.endDate) {
    return `${start.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "2-digit",
      year: "numeric",
    })}, ${event.time}`;
  }

  const end = parseApiDate(event.endDate);
  if (isNaN(end.getTime())) return "";

  const sameMonth =
    start.getMonth() === end.getMonth() &&
    start.getFullYear() === end.getFullYear();

  const startFormatted = start.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "2-digit",
    year: "numeric",
  });

  const endFormatted = end.toLocaleDateString(
    "en-US",
    sameMonth
      ? {
          weekday: "short",
          month: "short",
          day: "2-digit",
          year: "numeric",
        }
      : {
          weekday: "short",
          month: "short",
          day: "2-digit",
          year: "numeric",
        },
  );

  return `${startFormatted} - ${endFormatted}`;
};

export const getWeekday = (dateStr: string) => {
  const d = parseApiDate(dateStr);
  return isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("en-US", { weekday: "short" });
};

export const getMonthYearKey = (dateStr: string) => {
  const d = parseApiDate(dateStr);
  return isNaN(d.getTime())
    ? ""
    : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
